export default __webpack_public_path__ + "static/media/snipnchip_logo.7b25ba38.png";